import Reflux from 'reflux';

const AuthenticationActions = Reflux.createActions({
  load: { asyncResult: true },
  update: { asyncResult: true },
});

export default AuthenticationActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/authentication/AuthenticationActions.js